/* eslint-disable react/style-prop-object */
import React, { useEffect } from "react";
import { IOrganizationProductInstance, OrganizationProduct } from "../../../domain/OrganizationProduct";
import styles from "./RoleFilters.module.scss";
import { GenericDropdownFilter } from "../GroupFilters/GenericDropdownFilter";

export interface IRoleFilters {
    instance: IOrganizationProductInstance | null;
    product: OrganizationProduct | null;
}

export const RoleFilters = ({
    filters,
    onChange,
    products = [],
    disableInstances
}: {
    filters: IRoleFilters;
    onChange: (filters: IRoleFilters) => void;
    products: OrganizationProduct[];
    disableInstances?: boolean;
}) => {
    const updateProductSelection = ({ product }: { product: OrganizationProduct | null }) => {
        // if the product is changed, make sure to reset the instance
        onChange({ product, instance: null });
    };

    const updateInstanceSelection = ({ instance }: { instance: IOrganizationProductInstance | null }) => {
        onChange({ ...filters, instance });
    };

    const singleProduct = products.length === 1;
    const singleInstance = filters.product?.instances.length === 1;

    useEffect(() => {
        const selectedProduct = products.length === 1 ? products[0] : filters.product;
        const selectedInstance =
            filters.product?.instances.length === 1 ? filters.product?.instances[0] : filters.instance;

        if (selectedProduct || selectedInstance) {
            onChange({ product: selectedProduct, instance: selectedInstance || null });
        }
    }, [filters.product, filters.instance, products, onChange]);

    return (
        <div className={styles["role-filters"]}>
            <GenericDropdownFilter
                hideAllOption={singleProduct}
                label="Product"
                onChange={({ value }) => updateProductSelection({ product: value as OrganizationProduct | null })}
                options={products || []}
                value={filters?.product}
            />
            <GenericDropdownFilter
                disabled={!filters?.product || disableInstances}
                hideAllOption={singleInstance}
                label="Instance"
                onChange={({ value: instance }) => updateInstanceSelection({ instance })}
                options={filters?.product?.instances || []}
                value={filters?.instance}
            />
        </div>
    );
};

RoleFilters.displayName = "RoleFilters";
